const routes = {
  home: '/',
  login: '/login',
  signup: '/signup',
  reset: '/reset',
  resetConfirm: '/reset-password/:slug',
  validateAccount: '/validate-account',
  aboutUs: '/about-us',
  cookiePolicy: '/cookie-policy',
  contactUs: '/contact-us',
  dashboard: '/dashboard',
  venues: '/venues',
  venue: '/venue/:slug',
  venuesManage: '/manage/venues',
  venueManage: '/manage/venue/:slug',
  venueBookingDetail: '/venue/booking/:slug',
  venueBookingDetailPublic: '/public/venue/booking/:slug',
  staffsManage: '/manage/staff',
  staffManage: '/manage/staff/:slug',
  communitiesManage: '/manage/communities',
  communityManageStaff: '/manage/community/:slug',
  acceptInvitation: '/accept-invitation/:token',
  communityInvitation: '/community-invitation/:token',
  communities: '/communities',
  community: '/community/:slug',
  communityPublic: '/public/community/:slug',
  communityVenue: '/community/:slug/venue/:venueSlug',
  communityBooking: '/community/:slug/booking/:bookingSlug',
  // Community Management - unified for both users and staff (role-based access)
  communityManage: '/community/:slug/manage',
  events: '/events',
  eventAdmin: '/event-manage',
  eventUpdate: '/event-update/:slug',
  eventParticipant: '/events/:slug',
  eventTicket: '/event-ticket/:slug',
  bookings: '/bookings',
  booking: '/bookings/:slug',
  bookingResult: '/booking-result/:sessionId',
  bookingAdmin: '/booking-manage',
  bookingFind: '/booking-find',
  spaces: '/space',
  profile: '/profile',
  terms: '/terms-of-service',
  signUp: '/signup',
  checkMail: '/checkmail',
  onBoarding: '/on_boarding',
  error404: '/error/404',
  errorCommunity: '/error/no-community',
}

export default routes
